<div style="position: relative" [ngStyle]="{'height.px': height}">
  <div class="timeline" [ngStyle]="{'height.px': height}" style="background: rgba(var(--greenRGB), 0.2); width: 100%; position: absolute;">
    <div class="timeline" style="background: var(--green)" [ngStyle]="{'width.%': percent, 'background': percent > 100 ? 'var(--red)' : 'var(--green)', 'height.px': height}"></div>
  </div>
</div>